import React from 'react';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconMenu from 'material-ui/IconMenu';
import CircularProgress from 'material-ui/CircularProgress';
import Avatar from 'material-ui/Avatar';
import { grey50, grey100 } from 'material-ui/styles/colors';
import NavigationApps from 'material-ui/svg-icons/navigation/apps';
import { Link } from 'react-router-dom';

import { environment } from '../../environment';

const style = {
    managedBy: {
        fontSize: 12,
        padding: '4px 12px 8px 12px'
    },
    profileArea: {
        display: 'flex',
        background: 'white',
        padding: '12px 12px'
    },
    profilePicture: {
        flexGrow: 1
    },
    profileInfo: {
        alignSelf: 'center'
    },
    bottomLeft: {
        flexGrow: 1
    },
    bottomRight: {
        alignSelf: 'center'
    },
    bottom: {
        display: 'flex',
        marginTop: 12,
        padding: '0 12px'
    }
};

export default class Profile extends React.Component {
    render() {
        const auth = this.props.auth;

        return (
            <div style={{ display: 'flex' }}>
                <IconMenu
                    listStyle={{ background: grey100 }}
                    iconButtonElement={
                        <IconButton>
                            {auth.profile_photo_url && <Avatar src={auth.profile_photo_url} size={30} />}
                            {!auth.profile_photo_url && <CircularProgress color={grey50} />}
                        </IconButton>
                    }>

                    <div>
                        <div style={style.managedBy}>Conta gerenciada por <strong>GorillasCode</strong>.</div>

                        <div style={style.profileArea}>
                            <div style={style.profilePicture}>
                                {auth.profile_photo_url && <Avatar src={auth.profile_photo_url} size={72} />}
                            </div>
                            <div style={style.profileInfo}>
                                {auth.id &&
                                    <div>
                                        <div style={{ fontWeight: 'bold' }}>{auth.name}</div>
                                        <div style={{ fontSize: 12 }}>{auth.email}</div>
                                    </div>
                                }
                            </div>
                        </div>

                        <div style={style.bottom}>
                            <div style={style.bottomLeft}>
                                <IconButton tooltip="Meus Apps" tooltipPosition="top-center" style={{ marginLeft: 20 }}>
                                    <Link to={environment.appsUrl} target="_blank">
                                        <NavigationApps style={{ color: '#444' }} />
                                    </Link>
                                </IconButton>
                            </div>
                            <div style={style.bottomRight}>
                                <RaisedButton label="DESCONECTAR" onClick={this.props.logoff} />
                            </div>
                        </div>
                    </div>
                </IconMenu>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/layout/Profile.js